
document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
        if (event.target.matches('.ClickTolink')) {
          event.stopPropagation()
          const clickedElement = event.target;
  
  
                    var url = clickedElement.getAttribute('data-url');
                    window.location.href = url;
              }
            });
  });
        

